import { Icon } from "@iconify/react";
import { Button, Dialog } from "@mui/material";
import "./Components.css";
import "./WarningDialog.css";

const WarningDialog = ({
  confirmAction,
  contents,
  isOpen,
  isProcessing,
  setIsOpen,
}) => {
  return (
    <Dialog
      open={isOpen}
      className="dialog warning-dialog"
      fullWidth
      maxWidth="sm"
      scroll="paper"
      onClose={() => setIsOpen(false)}
    >
      <header>
        <Icon height="28" icon="ion:warning" width="28" />
        <p>Warning!</p>
        <Icon height="28" icon="ion:warning" width="28" />
      </header>

      <div className="dialog-content">
        {contents}

        <div className="buttons">
          <Button
            className="cancel"
            variant="outlined"
            onClick={() => setIsOpen(false)}
          >
            Cancel
          </Button>

          <Button
            disabled={isProcessing}
            variant="contained"
            onClick={confirmAction}
          >
            Confirm
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default WarningDialog;
